import React from "react";

export { dateSorter, sortByYear, sortByChildName } ;

const dateCompareFormat = ( dt ) =>
{
    return dt.substring(6, 10) + dt.substring ( 3,5) + dt.substring ( 0,2) ;
}

function xlateYear ( id )
{
    switch ( +id )
    {
        case 14:
            return 1 ;
            break ;
        case 15:
            return 2 ;
            break ;
        case 17:
            return 3 ;
            break ;
        case 1:
            return 4 ;
            break ;
        case 2:
            return 5 ;
            break ;
        case 3:
            return 6 ;
            break ;
        case 4:
            return 7 ;
            break ;
        case 5:
            return 8 ;
            break ;
        case 6:
            return 9 ;
            break ;
        case 7:
            return 10 ;
            break ;
        case 8:
            return 11 ;
            break ;
        case 9:
            return 12 ;
            break ;
        case 10:
            return 13 ;
            break ;
        case 11:
            return 14 ;
            break ;
        case 12:
            return 15 ;
            break ;
        case 13:
            return 16 ;
            break ;
        default:
            return 99 ;

    }
}

const sortByYear = (a, b, order, field, enumObject) =>
{
    if (order === 'desc')
    {
        if (xlateYear(+a.year_id) > xlateYear(+b.year_id))
        {
            return -1;
        }
        else if (xlateYear(+a.year_id)  < xlateYear(+b.year_id))
        {
            return 1;
        }
        return 0;
    }
    else
    {
        if (xlateYear(+a.year_id)  < xlateYear(+b.year_id))
        {
            return -1;
        }
        else if (xlateYear(+a.year_id) > xlateYear(+b.year_id))
        {
            return 1;
        }
        return 0;
    }
}

const dateSorter = (a, b, order, field, enumObject) =>
{
    const ac = dateCompareFormat(a) ;
    const bc = dateCompareFormat(b) ;

    if (order === 'desc')
    {
        if (ac > bc)
        {
            return -1;
        }
        else if (ac  < bc)
        {
            return 1;
        }
        return 0;
    }
    else
    {
        if (ac < bc)
        {
            return -1;
        }
        else if (ac > bc)
        {
            return 1;
        }
        return 0;
    }
}

const sortByChildName = (a, b, order, field, enumObject) =>
{
    if (order === 'desc')
    {
        if (a.child_surname > b.child_surname)
        {
            return -1;
        }
        else if (a.child_surname < b.child_surname)
        {
            return 1;
        }

        if (a.child_firstname > b.child_firstname)
        {
            return -1;
        }
        else if (a.child_firstname < b.child_firstname)
        {
            return 1;
        }

        return 0;
    }
    else
    {
        if (a.child_surname < b.child_surname)
        {
            return -1;
        }
        else if (a.child_surname > b.child_surname)
        {
            return 1;
        }

        if (a.child_firstname < b.child_firstname)
        {
            return -1;
        }
        else if (a.child_firstname > b.child_firstname)
        {
            return 1;
        }

        return 0;
    }
}